export const LOGIN_LINK = {
    id: 'login',
    label: 'Log In',
    isSPA: false,
    navigateTo: '/magic_links/new/'
};
export const LOGOUT_LINK = {
    id: 'logout',
    label: 'Log Out',
    isSPA: false,
    navigateTo: '/users/sign_out/'
};
export const APPLY_LINK_SHORT = {
    id: 'apply_now',
    label: 'Apply',
    isSPA: false,
    navigateTo: '/registration?utm_source=dojo'
};
export const APPLY_LINK = {
    id: 'apply_now',
    label: 'Apply Now',
    isSPA: false,
    navigateTo: '/registration?utm_source=dojo'
};
export const LINKS_LIST = [
    {
        id: 'personal_loans',
        label: 'Personal Loans',
        isSPA: false,
        navigateTo: 'https://www.creditninja.com/personal-loans/',
        subMenu: [
            {
                id: 'personal_loans_sub',
                label: 'Personal Loans',
                isSPA: false,
                navigateTo: 'https://www.creditninja.com/personal-loans/'
            },
            {
                id: 'bad_credit_loans_sub',
                label: 'Bad Credit Loans',
                isSPA: false,
                navigateTo: 'https://www.creditninja.com/bad-credit-loans/'
            },
            {
                id: 'online_installment_loans_sub',
                label: 'Online Installment Loans',
                isSPA: false,
                navigateTo: 'https://www.creditninja.com/installment-loans/'
            }
        ]
    },
    {
        id: 'resources',
        label: 'Resources',
        isSPA: false,
        navigateTo: 'https://www.creditninja.com/resources/',
        subMenu: [
            {
                id: 'resources_sub',
                label: 'Resources',
                isSPA: false,
                navigateTo: 'https://www.creditninja.com/resources/'
            },
            {
                id: 'financial_literacy_sub',
                label: 'Financial Literacy',
                isSPA: false,
                navigateTo: 'https://www.creditninja.com/financial-literacy/'
            },
            {
                id: 'financial_calculators_sub',
                label: 'Financial Calculators',
                isSPA: false,
                navigateTo: 'https://www.creditninja.com/financial-calculators/'
            },
            {
                id: 'glossary_sub',
                label: 'Glossary',
                isSPA: false,
                navigateTo: 'https://www.creditninja.com/glossary/'
            },
            {
                id: 'trends_stats_sub',
                label: 'Trends & Stats',
                isSPA: false,
                navigateTo: 'https://www.creditninja.com/trends-stats/'
            }
        ]
    },
    {
        id: 'about_us',
        label: 'About Us',
        isSPA: false,
        navigateTo: 'https://www.creditninja.com/about-us/',
        subMenu: [
            {
                id: 'about_sub',
                label: 'About Us',
                isSPA: false,
                navigateTo: 'https://www.creditninja.com/about-us/'
            },
            {
                id: 'reviews_sub',
                label: 'Reviews',
                isSPA: false,
                navigateTo: 'https://www.creditninja.com/reviews/'
            },
            {
                id: 'contact_sub',
                label: 'Contact Us',
                isSPA: false,
                navigateTo: 'https://www.creditninja.com/contact_us/'
            }
        ]
    },
    {
        id: 'faq',
        label: 'FAQ',
        isSPA: false,
        navigateTo: 'https://www.creditninja.com/faq/'
    },
    {
        id: 'blog',
        label: 'Blog',
        isSPA: false,
        navigateTo: 'https://www.creditninja.com/blog/'
    },
    {
        id: 'my_account',
        label: 'Account',
        isSPA: false,
        navigateTo: 'https://www.creditninja.com/portal/loan_status/'
    }
];
